import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/core/auth.service';
import { ErrorService } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { LOCAL_USERNAME_KEY } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-auth-mfa-form',
  templateUrl: './auth-mfa-form.component.html',
  styleUrls: ['./auth-mfa-form.component.scss'],
})
export class AuthMfaFormComponent implements OnInit, AfterViewInit {
  @ViewChildren('otp') otp?: QueryList<ElementRef>;
  auth_mfa_form_group: FormGroup = this.form_service.auth_mfa_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_auth_mfa_running: boolean = false;
  active_input_index: number = 0;

  constructor(
    private form_service: FormService,
    private auth_service: AuthService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
    private utils_service: UtilsService,
  ) {}

  ngAfterViewInit(): void {
    if (this.otp && this.otp.first) {
      this.otp.first.nativeElement.focus();
    }
  }

  ngOnInit(): void {
    this.auth_mfa_form_group.reset();
    this.utils_service.setActiveInput(0, this.auth_mfa_form_group);
  }

  onMoveToNext(event: any, current_index: number): void {
    const response = this.utils_service.moveToNext(event, current_index, this.auth_mfa_form_group, this.otp);
    if (response) {
      this.onVerifyClick();
    }
  }

  onMoveToPrev(event: KeyboardEvent, index: number): void {
    const response = this.utils_service.moveToPrev(event, index, this.auth_mfa_form_group, this.otp);
    if (response) {
      this.onVerifyClick();
    }
  }

  onPasteOtp(event: ClipboardEvent, current_index: number): void {
    const response = this.utils_service.pasteOtp(event, current_index, this.auth_mfa_form_group, this.otp);
    if (response) {
      this.onVerifyClick();
    }
  }

  getFormGroupControls(): number[] {
    return this.utils_service.getFormGroupControls();
  }

  onSetActiveInput(index: number): void {
    this.active_input_index = this.utils_service.setActiveInput(index, this.auth_mfa_form_group);
  }

  onVerifyClick(): void {
    if (this.isFormValid() && this.auth_service.pending_cognito_user) {
      const otp: string = this.utils_service.getOtpValue(this.auth_mfa_form_group);
      this.confirmSignin(otp);
    }
  }

  confirmSignin(otp: string): void {
    this.is_auth_mfa_running = true;
    this.auth_service.confirmSignin(this.auth_service.pending_cognito_user, otp).subscribe({
      next: response => {
        this.navigation_service.toHome();
        localStorage.setItem(LOCAL_USERNAME_KEY, response.attributes.email);
        this.is_auth_mfa_running = false;
      },
      error: error => {
        this.error_service.processApiError(error.code, error.message);
        this.is_auth_mfa_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.auth_mfa_form_group);
  }
}
